const categoryFields = [
  {
    name: "title",
    label: "Category Title",
    type: "text",
    placeholder: "Type category title",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Category Description",
  },
];

export default categoryFields;
